import { useSelector } from "react-redux" 
import { StateExtended } from "../../../_config/interfaces/stateExtended";

export function useUser() {
    const user = useSelector((state: StateExtended) => state.user)
    return user.user?.user
}

export function useToken(page:string = '') {
    const user = useSelector((state: StateExtended) => state.user)
    //  console.log("user==>", user?.user?.token)
    return user?.user?.token
}
